<!-- 精品果园详情 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col">
        <infoContent title="精品果园" label="FINE ORCHARD" :showTitle="true" :showMore="false" :infoBlock="infoBlock1" :info="detail"/>
        <infoContent title="果园简介" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock2"  :info="detail"/>
      </div>
    </div>
    <div class="content-row">
      <div class="content-col">
        <image-slide title="果园图集" label="FINE ORCHARD" :showTitle="true" :infoBlock='infoBlock3' :infoList="infoList1" count="6" col="3" warpH="400px"  v-on:queryPage="jpgy_Req"/>
      </div>
    </div>
    <div class="content-row">
      <div class="content-col">
        <image-slide title="果品集" label="FRUIT SET" :showTitle="true" :infoBlock='infoBlock4' :infoList='infoList2' count="4" col="4" warpH="250px"  btStyle="1"  v-on:queryPage="yzjd_Req"/>
      </div>
    </div>
    <div class="content-row">
      <div class="content-col">
        <infoContent title="果园地址"  label="ORCHARD ADDRESS" :showTitle="true" :showMore="false" :infoBlock="bdMap" :info="detail"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoContent from '../block/InfoContent'
import ImageSlide from '../block/ImageSlide'
import InfoBlock16 from '../block/InfoBlock16'
import InfoBlock17 from '../block/InfoBlock17'

import JpgyInfo1 from '../module/JpgyInfo1'
import JpgyInfo2 from '../module/JpgyInfo2'
import BdMap from '../module/BdMap'
export default {
  name: 'Jpgy01',
  components: {
    'image-slide':ImageSlide,
    'infoContent':InfoContent,
  },
  data() {
    return {
      msg: '',
      infoBlock1:JpgyInfo1,
      infoBlock2:JpgyInfo2,
      infoBlock3:InfoBlock16,
      infoBlock4:InfoBlock17,
      bdMap:BdMap,
      infoList1:[],
      infoList2:[],
      detail:{}
    }
  },
  methods:{
    detail_Req(detailId){
      let that=this;
      let params={id:detailId};
      that.$dataApi.tradeInfo(params).then(res =>{
          that.msg=res.msg;
          that.detail=res.data.info;

        });
    },
    //精品果园
    jpgy_Req(params){
          let that=this;
          //if(this.Global.siteTabId>0){params.tag_id=this.Global.siteTabId;}
          params.type=that.tabDefaultType;
          let result={page:params};
          params.pageSize=14;
          console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
          that.$dataApi.articleList(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          that.infoList1= res.data.list;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
    //优质基地
    yzjd_Req(params){
          let that=this;
          if(this.Global.siteTabId>0){params.tag_id=this.Global.siteTabId;}
          params.type=that.tabDefaultType;
          let result={page:params};
          params.pageSize=21;
          console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
          that.$dataApi.articleList(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          that.infoList2= res.data.list;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  },
  created:function(){
    let that=this;
    let detailId=that.$route.params.id;
    that.detail_Req(detailId);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.width-per-100{
  width:100%;
}
.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}

.page-back-style{
  background-image:url(./../../assets/jpgy_back.jpeg);
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position:0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Jpgy01Detail.vue